import React from "react";
import { IoPersonSharp } from "react-icons/io5";
import { useReveal } from "../../hooks/useReveal";
import styles from "./Pictogram.module.css";

export function Pictogram({
  filled,
  total,
  results,
}: {
  filled: number;
  total: number;
  results: readonly string[];
}) {
  const ref = useReveal<HTMLDivElement>();
  return (
    <div ref={ref} className={`ui-card ui-reveal ${styles.card}`}>
      <div
        className={styles.people}
        style={{ "--people": total } as React.CSSProperties}
        aria-hidden="true"
      >
        {Array.from({ length: total }, (_, i) => (
          <IoPersonSharp
            key={i}
            className={i < filled ? styles.filled : styles.empty}
            style={{ "--person-delay": `${i * 40}ms` } as React.CSSProperties}
          />
        ))}
      </div>
      <div>
        <h3 className={styles.label}>
          {filled} of {total} participants
        </h3>
        <ul className={styles.results}>
          {results.map((result) => (
            <li key={result}>{result}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
